<script>
  import { _ } from 'svelte-i18n';
  import { createEventDispatcher, onDestroy, onMount } from 'svelte';
  import { api, emojis } from '../../../../../helpers';
  import { changeToken } from '../../../../../Api';
  
  import ModalForSortListAndSmile from '../ModalForComments/ModalForSortListAndSmile.svelte';
  import CommentImages from '../CommentImages/CommentImages.svelte';
  import { addToast } from '../../../Toasts/store/index.js';
  
  const dispatch = createEventDispatcher();
  
  export let id_publicate;
  export let isChild;
  export let comment;

  $: replyName = comment.jwt_client.first_name;

  let inputRef;
  let text = '';
  let replyNameRef;
  let showEmoji = false;
  let files = [];

  const textareaHeight = '27px';

  const generateFormDataBody = () => {
    const data = new FormData();

    data.append('publication', id_publicate);
    data.append('parent', comment.pk);

    if (Array.from(files).length) {
      Array.from(files).forEach((file) => {
        data.append('images', file);
      });
    }

    data.append('text', text?.replace(/\n/g, '<br/>'));

    return data;
  }
  
  const createMessage = async () => {
    if (!text && !Array.from(files).length) {
      return;
    }

    const response = await api(
      '/api/v1/comment/create/', 
      'POST', 
      generateFormDataBody()
    );
    
    if (!response.ok) {
      changeToken(response.status);
    } else {
      const comment = await response.json();
      
      dispatch('created-comment', { comment });
    }

    text = '';
    showEmoji = false;
  };
  
  const addAmoji = (e)=> {
    text += e.target.textContent;
  };
  
  const keyUpHandler = (e) => {
    if (!text) {
      return;
    }
  
    if (e.key === 'Enter' && e.ctrlKey) {
      createMessage();
      showEmoji = false; 
    }
  }

  const deleteImage = (index) => {
    const fileBuffer = new DataTransfer();

    Array.from(files).forEach((file, i) => {
      if (index !== i) {
        fileBuffer.items.add(file);
      }
    });
    
    files = fileBuffer.files;
  }

  const checkCountFiles = () => {
    if (files.length > 5) {
      files = [];

      addToast($_('maxFilesWarning'));
    }
  }
  
  onMount(() => {
    inputRef.style.height = textareaHeight;
    inputRef.focus();
    inputRef.click();
  });

  onDestroy(() => {
    dispatch('hide')
  })
</script>

<div 
  class='main' 
  class:child={isChild}
>
  <!-- модальное окно emoji -->
  {#if showEmoji}
    <ModalForSortListAndSmile on:hide-popup={() => showEmoji = false}>
      <div class='emoji-cont'>
        <div class='close_emoji' on:click={()=> showEmoji = false}>
          <i class="icon-cross" />
        </div>

        {#each emojis as emoji}
          <span class='emo' on:click={addAmoji}>{emoji}</span>
        {/each}
      </div>
    </ModalForSortListAndSmile>
  {/if}

  <!-- поле ввода -->
  <div class="flex items-center">
    <div class='cont'>
      <div class="reply-name" bind:this={replyNameRef}>{replyName}, </div>

      <textarea
        on:input={() => {
          inputRef.style.height = "5px";
          inputRef.style.height = (inputRef.scrollHeight) + "px";
        }}
        maxlength='4000' 
        style:text-indent={`${replyNameRef?.clientWidth + 5}px`}
        bind:this={inputRef} 
        bind:value={text} 
        on:keydown={keyUpHandler}
      />

      <div class='flex items-center icons'>
        <div class='text-grey'>
          <input
            bind:files
            id="input__file"
            multiple
            accept='image/*'
            type="file"
            style={'display:none'}
            on:change={checkCountFiles}
          />
          <label for='input__file' class='input__file-button' >
            <span class='input__file-icon-wrapper'>
              <i class='icon-image'></i>
            </span>
          </label>
        </div>
    
        <i 
          class="icon-smile text-grey ml-md" 
          on:click|stopPropagation={()=> showEmoji = true} 
        />
      </div>
    </div> 
    
    <i class="icon-send" on:click={createMessage} />
  </div>

  <CommentImages 
    {files} 
    on:delete={(event) => deleteImage(event.detail.index)} 
  />
</div>
  
<style lang="scss">
  .reply-name {
    font-size: 14px;
    color:#30333D;
    position: absolute;
    left: 8px;
    top: 4px;
  }
  
  i::before {
    margin: 0;
  }

  .icons {
    position: absolute;
    top: 0;
    right: 8px;
  }

  .icon-cross {
    color: #BDBFC4;
    font-size: 12px;
  }

  .icon-smile {
    font-size: 18px;
  }

  :global(.loader-icon) {
    animation: rotation 1s linear infinite
  }

  @keyframes -global-rotation {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
  } 
  
  .main {
    display: flex;
    flex-direction: column;
    margin-left: 40px;

    &.child {
      margin-left: 102px;

      @media (min-width: 320px) and (max-width: 1000px) {
        margin-left: 82px;
      }
    }
  }
  
  .input__file-button {
    cursor: pointer;
  }
  
  .cont {
    position: relative;
    width: 100%;
    margin-top: -10px;
  }
    
   textarea {
    padding: 4px 65px 4px 8px;
    border: none;
    line-height: 18px;
    margin: 0;
    background: #E0E8F6;
    border-radius: 4px;
    box-sizing: border-box;
    overflow: hidden;
    width: 100%;
    height: 100%;
    resize: none;
    font-size: 14px;
    box-sizing: border-box;
  } 

  textarea:focus {
    font-size: 14px;
    outline: none;
    line-height: 18px;
  }
  
  ::placeholder {
    font-size: 14px;
    line-height: 18px;
    color: #30333D;
  }
  
  .icon-send {
    font-size: 18px;
    color: #2B50ED;
    margin-top: -15px;
    margin-left: 12px;
  }
  
  .emoji-cont{
    position:absolute;
    z-index: 999;
    height: 100px;
    width: 200px;
    margin-left: 80px;
    margin-top: -150px;
    right: 35px;
    overflow: auto;
    padding: 10px 0 10px 10px;
    border-radius: 10px;
    box-shadow: 0px 2px 10px rgba(48, 51, 61, 0.26);
    background:white;
    animation: ani 0.2s forwards;
  }
  @keyframes ani {
    0% {transform: translateY(10%);}
    100% {transform: translateY(0);}
  }
  
  .emo{
    margin: 5px; 
   cursor: pointer;
  }
  
  .close_emoji{
    padding-left: 161px;
    cursor: pointer;
    padding-bottom: 5px;
  }
</style>
  